// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const ADD_MODULATION_DETAILS = 'ADD_MODULATION_DETAILS'
export const ASSIGN_ENTITY_DETAILS = 'ASSIGN_ENTITY_DETAILS'
export const REMOVE_MODULATION_FROM_STATE = 'REMOVE_MODULATION_FROM_STATE'
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE'
export const UPDATE_STORED_MODULATION_DETAILS = 'UPDATE_STORED_MODULATION_DETAILS'
